import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { AuthService, HelpersService } from '@evento-ng/libs';

@Component({
  selector: 'app-review-details',
  templateUrl: './review-details.component.html',
  styleUrls: ['./review-details.component.scss'],
})
export class ReviewDetailsComponent {
  @Input() event;
  @Input() invoice;
  @Input() showPage;
  @Output() detailsMobileOpened = new EventEmitter();
  user: any;
  openPlolicies = false;
  isMobile = false;
  isSport = false;
  openDetails = false;
  constructor(
    public helpers: HelpersService,
    public ticketService: TicketService,
    private authService: AuthService,
    public translate: TranslateService,
    private router: Router
  ) {
    this.isSport = this.router.url.includes('sport');
    this.user = this.authService.user.getValue();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  ngOnChanges() {
    if (this.showPage) {
      this.openDetails = false;
    }
  }

  openDetailsFunction() {
    this.openDetails = true;
    this.detailsMobileOpened.emit(true);
  }
}
